<template>
  <div>
    layout
  </div>
</template>

<script>
  export default {
    name: 'TabLayout',    
  }
</script>

<style lang="less">

</style>